import { render, staticRenderFns } from "./AddAccreditedSchool.vue?vue&type=template&id=20d2e9f6&scoped=true"
import script from "./AddAccreditedSchool.vue?vue&type=script&lang=js"
export * from "./AddAccreditedSchool.vue?vue&type=script&lang=js"
import style0 from "./AddAccreditedSchool.vue?vue&type=style&index=0&id=20d2e9f6&prod&scoped=true&lang=css"
import style1 from "./AddAccreditedSchool.vue?vue&type=style&index=1&id=20d2e9f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d2e9f6",
  null
  
)

export default component.exports